import React from "react";

const Steps = () => {
  return (
    <div class="container">
      <section className="section">
        <div className="row align-items-center">
          {/* Image Column */}
          <div className="col-md-6 text-center mb-4 mb-md-0">
            <img
              src="assets/images/summary.png"
              alt="Steps Preview"
              className="img-fluid shadow-lg rounded-4"
              style={{ maxWidth: "100%" }}
            />
          </div>

          {/* Steps Column */}
          <div className="col-md-6">
            <h2 className="mb-4 text-center text-md-start">
              Simple Steps to Success
            </h2>

            {/* Step 1 */}
            <div className="d-flex mb-4 align-items-start">
              <div
                className="icon-circle d-flex align-items-center justify-content-center me-3"
                style={{
                  width: "60px",
                  height: "60px",
                  backgroundColor: "#e34848",
                  color: "#fff",
                  borderRadius: "50%",
                }}
              >
                <i className="bi bi-person-check fs-4"></i>
              </div>
              <div>
                <h5 className="mb-1">Sign Up</h5>
                <p className="mb-0">
                  Register with your email to access the dashboard
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="d-flex mb-4 align-items-start">
              <div
                className="icon-circle d-flex align-items-center justify-content-center me-3"
                style={{
                  width: "60px",
                  height: "60px",
                  backgroundColor: "#e34848",
                  color: "#fff",
                  borderRadius: "50%",
                }}
              >
                <i className="bi bi-shop fs-4"></i>
              </div>
              <div>
                <h5 className="mb-1">Customize Your Store</h5>
                <p className="mb-0">Add banners, sliders, popups, and more.</p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="d-flex align-items-start">
              <div
                className="icon-circle d-flex align-items-center justify-content-center me-3"
                style={{
                  width: "60px",
                  height: "60px",
                  backgroundColor: "#e34848",
                  color: "#fff",
                  borderRadius: "50%",
                }}
              >
                <i className="bi bi-cash-stack fs-4"></i>
              </div>
              <div>
                <h5 className="mb-1">Start Selling</h5>
                <p className="mb-0">
                  Paste the link in your frontend and start accepting orders.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Steps;
